export const flattenClasses = (classes: string[]): string =>
  classes.filter(Boolean).join(' ');
